export default __webpack_public_path__ + "static/media/998.ad7b55f0.png";